import LIFI from '@lifi/sdk';

const LiFi = new LIFI();

export default LiFi;
